<template>
  <div class="container">
	  <div class="loginContent">
		  <div class="w1600">
			 <div class="registerForm">
			 	<div class="loginForm p3 bd10">
			 			<h3 class="font28">{{$t('findPassword.title')}}</h3>
			 			<p class="font18 font-light tip cor999">{{$t('findPassword.titleTip')}}</p>
			 			<!-- 1 -->
			 			<div class="rgStep1">
			 				<div class="form">
			 					<dl>
			 						<dd class="d-flex f-colu">
			 							<div class="label font-medium">{{$t('commom.email')}}<tip></tip></div>
			 							<div class="enter d-flex code">
			 								<input type="text" v-model="formData.email" class="input font-light" :placeholder="$t('commom.emailPlaceholder')">
			 								<button class="fmBtn pointer font-light" @click="getCode">{{codeText}}</button>
			 							</div>
			 						</dd>
			 						<dd class="d-flex f-colu">
			 							<div class="label font-medium">{{$t('commom.code')}}</div>
			 							<div class="enter">
			 								<input type="text" maxlength="6" v-model="formData.code" class="input font-light" :placeholder="$t('commom.codePlaceholder')">
			 							</div>
			 						</dd>
			 						<dd class="d-flex f-colu">
			 							<div class="label font-medium">{{$t('findPassword.newPassword')}}<tip></tip></div>
			 							<div class="enter">
			 								<input type="password" v-model="formData.password" class="input font-light" :placeholder="$t('findPassword.newPassword')">
			 							</div>
										 <div class="passwordLevel d-flex" v-if="formData.password" :class="passwordLevel">
											<div class="lv d-flex"><i></i><i></i><i></i></div>
											<div class="lt"><span>弱</span><span>中</span><span>强</span></div>
										</div>
			 						</dd>
			 						<dd class="d-flex f-colu">
			 							<div class="label font-medium">{{$t('commom.confirmPassword')}}</div>
			 							<div class="enter">
			 								<input type="password" v-model="formData.confirmPassword" class="input font-light" :placeholder="$t('commom.confirmPassword')">
			 							</div>
			 						</dd>
			 					</dl>
			 				</div>
			 				<div class="submit d-flex">
			 					<button @click="checkVerify" class="fmBtn font20 w100 font-medium pointer">{{$t('findPassword.submit')}}</button>
			 				</div>
			 			</div>
			 			
			 	</div>
			 	<verify :show="showVerify" @success="handleVerify"></verify>
			 	<!-- 弹窗提示 -->
			 	<popup v-show="popupHandle">
			 		<div class="slot d-flex f-colu j-center a-center line-md">
			 			<img src="@/assets/Icons/error.png" alt="">
			 			{{message}}
			 		</div>
			 	</popup>
			 </div>
		  </div>
	  </div>
  </div>
</template>

<script>
// 邮箱验证
let ruleEmail = /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
export default {
  name: 'FindPassword',
  data() {
    return {
		// 表单
		formData: {
			email: '', // 邮箱
			code: '', // 验证码
			password: '', // 密码
			confirmPassword: '', // 确认密码
		},
		codeNumber: 60, // 获取验证码读秒
		message: '', // 提示
		popupHandle: false, // 控制提示弹窗是否显示
		sendStatus: true, // 验证码状态
		sendTimer: null, // 验证码定时器
		codeText: this.$t('commom.sendCode'), // 发送按钮文字
		passwordLevel:'',
		showVerify:false
	}
  },
  
  watch:{
	'formData.password':function(val) {
		this.passwordLevel='l'+this.checkPasswordStrength(val);
	}
  },
  methods: {
	checkVerify(){
		let that = this;
		  // 单独对邮箱进行验证
		  if (!ruleEmail.test(this.formData.email) || !this.formData.code.trim()) {
		    this.message = this.$t('commom.codeError');
		    this.popupHandle = true;
		    return;
		  }
		  // 对密码进行验证
		  if (!this.formData.password.trim() || !this.formData.confirmPassword.trim()) {
		    this.message = this.$t('commom.passwordEmpty');
		    this.popupHandle = true;
		    return;
		  }
		  if (this.formData.password.trim().length<8) {
		    this.message = this.$t('commom.passwordLengthWram');
		    this.popupHandle = true;
		    return;
		  }
		  if(this.formData.password.trim() === this.formData.confirmPassword.trim()) {}else{
			  this.message = this.$t('commom.passwordNot');
			  this.popupHandle = true;
			  return;
		  };
		that.showVerify=true;
	  },
	  handleVerify(){
		var that=this;
		that.showVerify=false;
		that.submitForm();
	  },
	checkPasswordStrength(password) {
		let strength = 1;
		// 判断密码是否包含大小写字母和数字，且长度大于等于8位
		if (/[a-z]/.test(password) && /[A-Z]/.test(password) && /\d/.test(password) && password.length >= 8) {
			strength = 3;
		} else if (password.length >= 8||(/[a-z]/.test(password) && /[A-Z]/.test(password) && /\d/.test(password))) {
			strength = 2;
		}
		return strength;
	},
	  tableContent(index) {
		  this.currentContent = index;
	  },
	  
	  // 页面跳转
	  goToPage(path, query={}) {
		  this.$router.push({
			path,
			query
		  })
	  },
	  
	  // 获取验证码
	  getCode() {
		  let that = this;
		  // 单独对邮箱进行验证
		  if (!ruleEmail.test(this.formData.email)) {
			this.message = this.$t('commom.emailError');
			this.popupHandle = true;
			return;
		  }
		  if(this.sendStatus) {
			  this.sendStatus = false;
			  this.$axios.get(`verifyMember/sendEmailCode?email=${this.formData.email}&type=password`)
			  .then(res => {
				  this.$message({
					message: this.$t('commom.sendSuccess'),
					type: "success"
				  });
			  })
			  .catch(err => {});
			  this.sendTimer = setInterval(() => {
				that.codeNumber--;
				if (that.codeNumber <= 0) {
				  that.codeNumber = 60;
				  that.codeText = this.$t('commom.sendCode');
				  that.sendStatus = true;
				  clearInterval(that.sendTimer);
				} else {
				  that.codeText = that.codeNumber + "s";
				}
			  }, 1000);
		  }
	  },
	  
	  // 提交修改
	  submitForm() {
		  let that = this;
		  
		  // 先对验证码进行验证
		  let formData = new FormData();
		  // 遍历对象进行枚举
		  Object.keys(that.formData).forEach(function(key) {
		     formData.append(key, that.formData[key]);
		  });
		  this.$axios({
			  method: 'post',
			  url: 'verifyMember/retrievePwd',
			  headers: {'Content-Type':'multipart/form-data'},
			  data: formData
		  }).then(res => {
			  this.$message({
				message: this.$t('findPassword.changeSuccess'),
				type: 'success'
			  });
			  // 1s后跳转登录
			  setTimeout(()=>{
				this.$router.push('/login');
			  }, 1000);
		  })
		  .catch(err => {});
	  }
  }
}
</script>

<style lang="less" scoped>
	.container{
		background: #f2f5fa;
	}
	.loginContent{
		padding: .6rem 0;
	}
	.loginForm{
		max-width: 500px;
		width: 100%;
		padding-top: .5rem;
		padding-bottom: .5rem;
		border-radius: 0;
		margin: 0 auto;
		.tip{
			margin: .15rem 0 .4rem;
		}
		dl{
			dd{
				.label{
					margin-bottom: .1rem;
				}
				&:not(:last-child) {
					margin-bottom: .3rem;
				}
				.fmBtn{
					width: 1.1rem;
				}
				.input,.fmBtn{
					border-radius: 0;
				}
				.code .input{
					width: calc(100% - 1.1rem);
				}
				.item{
					width: 48%;
				}
			}
		}
		.submit{
			margin-top: .4rem;
			p{
				margin-top: .4rem;
				a{
					color: #224ed9;
					padding-bottom: .1rem;
					border-bottom: solid 1px #224ed9;
				}
			}
		}
	}
</style>
